<template>
  <BaseLayout>
    <div class="registeredFulfill">
      <img class="RegisteredLogoedImage m-b-50" src="./assets/registered-logo-ed.png" />
      <div class="title">密码修改完成</div>
    </div>
  </BaseLayout>
</template>

<script>
document.getElementsByTagName('title')[0].innerText = '注册成功'
</script>
<style lang="scss">
@import './utils.scss';
.registeredFulfill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  background: linear-gradient(0deg, #f5f8ff 0%, #ffffff 100%);
  .RegisteredLogoedImage {
    width: 115px;
    height: 113px;
  }
  .primary-font {
    color: #2c55ed;
  }
  .RegisteredLogoImage {
    width: 94px;
    height: 112px;
    margin-bottom: 50px;
  }
  .title {
    font-size: 34px;
    margin-bottom: 144px;
    color: #333;
  }
  .title-samll {
    font-size: 32px;
    color: #333;
  }
  .label {
    font-size: 28px;
  }
  .label-black {
    font-size: 28px;
    color: #1f2329;
  }
  .appQRcode-box {
    position: relative;
    // padding: 20px;
    background-color: #fff;
    overflow: hidden;
    .appQRcodeIosImage {
      width: 192px;
      height: 192px;
    }
    .appQRcodeAndroidImage {
      width: 192px;
      height: 192px;
    }
  }
}
</style>